import { Component, ViewChild, ElementRef } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { HttpCustomerService } from '../../../../service/httpcustomer.service';
import { CommonService } from '../../../../service/common.service';
import { WebParameterContext } from '../../../../model/common';
import {AppPageElementType} from '../../../../model/xmlconfig/app.page.element.type';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
declare var echarts;//设置echarts全局对象
declare var app;
@Component({
  selector: 'app-mz-head-sa',
  templateUrl: './mz-head-sa.component.html',
  styleUrls: ['./mz-head-sa.component.scss']
})
export class MzHeadSaComponent extends GridBaseCase {
  dataArrayList: any = {visit:{value:0,text:"暂无数据"},work:{value:0,text:"暂无数据"},store:{value:0,text:"暂无数据"},Way:{value:0,text:"暂无数据"},today:{value:0,text:"暂无数据"}};
  store:any = null;
  @ViewChild('echartsContent') container: ElementRef;//与html中div #container1对应
  // @ViewChild('echartsContent2') container2: ElementRef;//与html中div #container1对应
  EChart: any;
  constructor(
    public com: CommonService,
    private http: HttpCustomerService, 
    private activaRouter: ActivatedRoute,
    private msg: MessageclientService,
    private router: Router
    ) {
    super();
    const that = this;
   
  }


 
  // echart2: any;
  ngOnInit() {
    const that = this;
    if(that.config.length>0){
      that.config.forEach((ele)=>{
        if(ele.type.toString().toLocaleLowerCase()=="head_sa"){
          that.element=ele;
        }else if(ele.type.toString().toLocaleLowerCase()=="button_link1"){
          that.store=ele;
        }
      })
    }
  that.LoadData();
  }
  LoadData(){
    const that = this;
    const pageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const types = that.activaRouter.snapshot.paramMap.get('type');
    let  id:any =null;
    if(that.activaRouter.snapshot.paramMap.get('id')){
      id = that.activaRouter.snapshot.paramMap.get('id').split('&')[0];
    }
    if(that.element.selectItemList.selectItem.length>0){
      let body: WebParameterContext = new WebParameterContext();
      if (that.element.selectItemList.gridViewConfigName) {
        body.ConfigName = that.element.selectItemList.gridViewConfigName;
      } 
      body.OpType = "query";
      body.ConfigType = "view";
      body.Client.PageName = pageName;
      // body.RequestBody = JSON.stringify({"a_ID":id});
      that.http.post(app.DEFAULTURL, body).then(data => {
        if (data.ResponseMessage.Success) {
          // console.log(data);
          let objfield = {};
          if(data.Status.Datas.length>0){
            data.Status.Datas.forEach(function (item) {
              that.element.selectItemList.selectItem.forEach((element, index) => {
                if(element.bindingField){
                  objfield[element.bindingField] = {"value":item[element.field],"text":element.text};
                }
              });
            });
            
            that.dataArrayList = objfield;
            that.echartBind();
          }
        
        } else {
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
      }).catch(error => {
        that.msg.Alert(error.ResponseMessage.ErrorMessage);
      });
    }
  }
  /**
   * 调转链接
   * @param ev url
   */
  storeEvent(ev){
    let evs = ev.url || '';
    if (evs.trim()) {
      if (evs.indexOf("http") > 0) {
        this.com.goWebPage(evs,"");
      } else {
        // console.log("2008");
        // console.log(this.dataArrayList);
        this.com.Go(evs);
      }
    }
  }
  echartBind() {
    let maxnum = 100;
    let number = 0;//当前值
    if(this.dataArrayList["today"]){
      number = this.dataArrayList["today"].value||0;
    }
    if(number>maxnum){
      maxnum=maxnum+100;
    }
    let ctelement = this.container.nativeElement;
    this.EChart = echarts.init(ctelement);
    let options = {
      backgroundColor: null,
      color: ['#86d6f6', '#fff'],
      series: [{
        name: '目标',
        type: 'pie',
        radius: ['80%', '90%'],
        avoidLabelOverlap: false,
        hoverAnimation: false,
        label: {
          normal: {
            show: false,
            position: 'center',
            textStyle: {
              fontSize: 12,
              color: '#fff',
              fontWeight: 'bold'
            },
            formatter: function () {
              return ""
            }
          }
        },
        data: [{
          value: number,
          name: '完成率',
          label: {
            normal: {
              show: true
            }
          }
        },
        {
          value: maxnum - number,
          name: ''
        }
        ]
      }]
    };
    this.EChart.setOption(options);
  }
  onResize() {
    this.EChart.resize();
  }


}
